import inView from 'in-view';

export default function video() {
  $('.wp-block-video').each(function () {
    const video = $(this).find('video');
    const $hover = $(this).find('.wp-block-video__hover');

    if ($hover.length) {
      video.on('play', function () {
        $hover.fadeOut();
      });
      $hover.on('click', function () {
        video.get(0).play();
      });
    }

    if (video.attr('data-autoplay')) {
      const id =
        video.attr('id') ||
        `in-view-${Math.random().toString(36).substr(2, 9)}`;
      video.attr('id', id);

      const selector = `#${id}`;

      inView(selector).once('enter', function (el) {
        setTimeout(function () {
          video.get(0).play();
        }, 1000);
      });
    }
  });

  // Play youtube video on click
  $('.play-youtube-video').each(function () {
    const $link = $(this).find('a');
    const selector = $link.attr('href').replace('#', '');
    const $target = $(`#${selector}, .${selector}`);
    if ($target.length) {
      $target.hide();
      $link.on('click', function (e) {
        e.preventDefault();
        const $autoplay = $target.clone();
        const src = `${$autoplay.find('iframe').attr('src')}&autoplay=1`;
        $autoplay.find('iframe').attr('src', src);
        $('#modal .modal-body').html($autoplay);
        $autoplay.show();
        $('#modal').modal();
      });

      $('#modal').on('hidden.bs.modal', function () {
        $('#modal .modal-body').empty();
      });
    }
  });
}
